import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { SectorForm } from "../SectorForm";
import { EditSectorModalProps } from "./types";
import { useEditSectorModal } from "./controller";

export const EditSectorModal = React.memo(({ modalRef, onComplete }: EditSectorModalProps) => {
  const translate = useTranslate();

  const { methods, handleSubmit, isPending } = useEditSectorModal(modalRef, onComplete);

  return (
    <Modal
      ref={modalRef}
      title={translate("book_sector_admin.titles.edit")}
      onConfirm={handleSubmit}
      methods={methods}
      isPending={isPending}
    >
      <SectorForm />
    </Modal>
  );
});
